import React from 'react';
import type { JSX } from 'react';
import { Navigate } from 'react-router';
import authTokenUtil from '../../account/authTokenUtil';
import { UserType } from '../../graphql/generated/graphql';
import useAppSelector from '../redux/useAppSelector';

interface EnsureAnonymousProps {
  children: JSX.Element;
}

const EnsureAnonymous = ({ children }: EnsureAnonymousProps) => {
  const user = useAppSelector((state) => state.session.user);

  if ((user.id && user.type !== UserType.Visitor) || authTokenUtil.get()) {
    const url = new URL(window.location.href);

    return <Navigate to={url.searchParams.get('redirect') || '/'} replace />;
  }

  return children;
};

export default EnsureAnonymous;
